export { icons as merchantIcons } from './icons';
